import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_UTILS_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${process.env.REACT_APP_UTILS_API_KEY}`
    }
});

const shortUrl = async (url) => {
    const response = await api.post(`/create`, {
        url: url,
        expiration_days: 0
    });

    if (response.status === 200) {
        return response.data.data.shortenUrl;
    }
    
    return url;
}


export { shortUrl };